import React, { useState } from 'react';
import css from './CareerFaqList.module.css';
import IconCard from '../../../../../components/SavedCardDetails/IconCard/IconCard';
import { useIntl } from 'react-intl';

function CareerFaqList({
  title,
  subtitle,
  faqs,
  ctaText,
  onCtaClick,
}) {
  const intl = useIntl();
  const t = (id, def) => intl.formatMessage({ id, defaultMessage: def });

  const resolvedTitle = title || t('CareerFaq.title', 'Arabibi frequently asked questions');
  const resolvedSubtitle =
    subtitle ||
    t(
      'CareerFaq.subtitle',
      "Stuck something? We’re here to help with all your questions and answer in one place"
    );
  const resolvedCta = ctaText || t('CareerFaq.cta', 'Read More Faqs');

  const defaultFaqs = [
    { q: t('CareerFaq.q1', 'How do I apply for a role at Arabibi?'), a: t('CareerFaq.a1', 'You can view the available positions on this page and follow the instructions listed under each role. For now, applications are submitted directly by email. admin@arabibi.com') },
    { q: t('CareerFaq.q2', 'Can I apply even if there are no current openings?'), a: t('CareerFaq.a2', 'Yes. If you believe you’re a strong fit for Arabibi, you can email your CV and a short introduction. We review all submissions and contact candidates when suitable roles open.') },
    { q: t('CareerFaq.q3', 'Do you offer remote positions?'), a: t('CareerFaq.a3', 'Yes. Many of our roles — especially teaching, support, and content-related positions — can be completed remotely. Each job description will specify whether the role is remote or location-based.') },
    { q: t('CareerFaq.q4', 'What qualifications do tutors need?'), a: t('CareerFaq.a4', 'Tutors must be native Arabic speakers with strong teaching skills, excellent communication, and a passion for helping students learn. Teaching certificates or previous experience are highly preferred.') },
    { q: t('CareerFaq.q5', 'How does the hiring process work?'), a: t('CareerFaq.a5', 'Our process includes reviewing your CV, a short screening call, and (for tutors) a teaching demonstration. You’ll receive clear instructions at each stage.') },
  ];

  const faqItems = Array.isArray(faqs) && faqs.length ? faqs : defaultFaqs;
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (idx) => {
    setOpenIndex((prev) => (prev === idx ? -1 : idx));
  };

  return (
    <section className={css.careerFaqWrapper}>
      <div className={css.info}>
        <h2 className={css.heading}>{resolvedTitle}</h2>
        <p className={css.subheading}>{resolvedSubtitle}</p>
      </div>

      <div className={css.faqList}>
        {faqItems.map((item, idx) => {
          const isOpen = idx === openIndex;
          return (
            <div key={idx} className={`${css.item} ${isOpen ? css.itemOpen : ''}`}>
              <button className={css.itemHeader} onClick={() => toggle(idx)} aria-expanded={isOpen}>
                <span className={css.question}>{item.q}</span>
                <span className={css.icon} aria-hidden>
                  {isOpen ? <IconCard type="minusicon" /> : <IconCard type="plusicon" />}
                </span>
              </button>
              {isOpen && (
                <div className={css.itemBody}>
                  {item.a && <p>{item.a}</p>}
                </div>
              )}
            </div>
          );
        })}

        <div className={css.ctaRow}>
          <a
            href="/faq"
            className={css.ctaButton}
          >  
            {resolvedCta}
          </a>
        </div>
      </div>
    </section>
  );
}

export default CareerFaqList;